import React, { useState } from "react";
import { Box, Button, Divider, useTheme } from "@mui/material";
import { ReactComponent as BackIcon } from "../images/svg/back.svg";
import { ReactComponent as ForwardIcon } from "../images/svg/forward.svg";
import { useColourMode } from "../contexts/ColourContext";
import { ReactComponent as SearchIcon } from "../images/svg/search.svg";

const UserLog = ({
  header,
  data,
  currentPage,
  setCurrentPage,
  itemsPerPage,
}) => {
  const [searchLog, setSearchLog] = useState("");

  const colourTheme = useTheme();
  const { accentColour } = useColourMode();
  const sortedData = [...data]
    .filter((user) => user.username !== "kanyin@banilux.ng")
    .sort((a, b) => b.id - a.id);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  const currentData = sortedData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const handleSearchChange = (e) => {
    setSearchLog(e.target.value);
  };

  const filteredLog = currentData?.filter(
    // Apply the search filter after sorting
    (user) => user.username?.toLowerCase().includes(searchLog.toLowerCase())
  );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "0.5rem",
        }}
      >
        <Box sx={{ fontSize: "1.25rem" }}>{header}</Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
          }}
        >
          <Button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            width="2rem"
            variant="contained"
          >
            <BackIcon style={{ height: "1rem", width: "1rem" }} />
          </Button>
          <Box
            sx={{
              marginLeft: "0.5rem",
              marginRight: "0.5rem",
              fontSize: "0.75rem",
            }}
          >{`Page ${currentPage} of ${totalPages}`}</Box>
          <Button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            variant="contained"
          >
            <ForwardIcon style={{ height: "1rem", width: "1rem" }} />
          </Button>
        </Box>
      </Box>
      <Box
        sx={{
          backdropFilter: "blur(1rem)",
          boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
          width: "100%",
          border: `1px solid ${colourTheme.palette.text.primary}`,
          borderRadius: "1rem",
          m: "auto",
          mb: 2.5,
          p: 1.5,
          height: "auto",
        }}
      >
        {/* Search */}
        <Box
          onClick={(e) => e.stopPropagation()}
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            border: `1px solid ${colourTheme.palette.text.primary}`,
            padding: "0.125rem 0.25rem",
            borderRadius: "0.5rem",
          }}
        >
          <Box>
            <input
              type="text"
              value={searchLog}
              onChange={handleSearchChange}
              placeholder="Search Log..."
              style={{
                width: "80%",
                padding: "0.25rem",
                background: "none",
                border: "none",
                outline: "none",
                color: colourTheme.palette.text.primary,
              }}
            />
          </Box>
          <Box sx={{ display: "grid", placeItems: "center" }}>
            <SearchIcon
              style={{
                width: "0.75rem",
                height: "0.75rem",
                cursor: "pointer",
                color: colourTheme.palette.text.primary,
              }}
            />
          </Box>
        </Box>

        <table style={{ width: "100%", marginTop: "0.5rem" }}>
          <thead>
            <tr>
              <th style={{ textAlign: "left" }}>User</th>
              <th style={{ textAlign: "end" }}>Last Logged In</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan="2" style={{ padding: 0 }}>
                <Divider style={{ width: "100%" }} />
              </td>
            </tr>
            {filteredLog.map((user, index) => (
              <tr
                key={user.id}
                style={{
                  color: index % 2 === 0 ? "" : "grey",
                  fontSize: "0.75rem",
                }}
              >
                <td style={{ textAlign: "left" }}>{`${user.username}`}</td>
                <td style={{ textAlign: "end" }}>{user.time}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </>
  );
};

export default UserLog;
